import React, { Component } from 'react'
import { Navbar, Nav, NavDropdown, Row, Col, Image } from 'react-bootstrap'
import DRYCOM from './Encabezado/DRYCOM.jpg'
import "./Navigation.css";

export class Navigation extends Component {
    render() {
        return (
            /* Aplicamos la misma protección de capa visual que en el Header de inglés */
            <div style={{ position: 'relative', zIndex: 10, background: 'white' }}>
                
                {/* Altura mínima para que el espacio del logo sea respetado durante animaciones */}
                <Row className="align-items-center" style={{ minHeight: '150px', margin: 0 }}>
                    <Col></Col>
                    <Col xs={8} md={6} className="d-flex justify-content-center">
                        <Image src={DRYCOM} width="65%" style={{ maxWidth: '400px' }} />
                    </Col>
                    <Col></Col>
                </Row>

                <Navbar collapseOnSelect bg="primary" expand="lg" variant="dark" className="shadow-sm">
                    <Navbar.Toggle aria-controls="basic-navbar-nav" className="ms-3" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-3">
                            <Nav.Link href="/">Inicio</Nav.Link>
                            <Nav.Link href="/cadenaFrio">Cadena de frío</Nav.Link>
                            <Nav.Link href="/instrumental">Instrumental</Nav.Link>
                            <Nav.Link href="/insumo">Insumo medico</Nav.Link>
                            
                            <NavDropdown title="Medicamento" id="nav-dropdown-meds">
                                <NavDropdown.Item href="/comerciales">Comerciales</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/generico">Genéricos</NavDropdown.Item>
                            </NavDropdown>

                            <NavDropdown title="Mobiliario y equipo" id="nav-dropdown-furniture">
                                <NavDropdown.Item href="/clinico">Clínico</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/diagnostico">Diagnóstico</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/emergencia">Emergencia</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/encamamiento">Encamamiento</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/ginecologia">Ginecología</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/intensivo">Intensivo</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/equipoMedico">Médico/Educativo</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/neonatologia">Neonatología</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/talla">Peso y Talla</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/rehabilitacion">Rehabilitación</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/operaciones">Sala de Operaciones</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/auxilios">1eros Auxilios</NavDropdown.Item>
                            </NavDropdown>

                            <Nav.Link href="/construcciones">Construcciones</Nav.Link>
                            <Nav.Link href="/contacto">Contactenos</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>

                    <Navbar.Collapse className="justify-content-end me-3">
                        <Navbar.Text className="text-white">
                            Go to page in <a href="/en/Home" className="text-white fw-bold">English</a>
                        </Navbar.Text>
                    </Navbar.Collapse>
                </Navbar>
            </div>
        )
    }
}